import * as React from 'react';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import { Home } from './Home';
import { Page1 } from './Page1';
import { Page2 } from './Page2';
var App = function () { return (React.createElement(Router, null,
    React.createElement(Switch, null,
        React.createElement(Route, { path: '/', exact: true, component: Home }),
        React.createElement(Route, { path: '/page1', component: Page1 }),
        React.createElement(Route, { path: '/page2', component: Page2 })))); };
export default App;
